module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/ppelv9-925c4dae405d316fa3d490abc26dd640.jpg";